import { render, staticRenderFns } from "./Mundial.vue?vue&type=template&id=4acf12f4&"
import script from "./Mundial.vue?vue&type=script&lang=js&"
export * from "./Mundial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports